import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducer";

import monitorReducersEnhancer from "./enhancers/monitorReducer";
import loggerMiddleware from "./middlewares/logger";

export default function configureAppStore(preloadedState) {

    const isDev = process.env.NODE_ENV === "development";
    
    const store = configureStore({
        reducer: rootReducer,
        middleware: getDefaultMiddleware =>
            isDev ? getDefaultMiddleware().prepend(loggerMiddleware) : getDefaultMiddleware(),
        preloadedState,
        devTools: {
            trace: true,
            traceLimit: 25
        },
        enhancers: (getDefaultEnhancers) => {
            const enhancers = getDefaultEnhancers();
            return isDev ? enhancers.concat(monitorReducersEnhancer) : enhancers;
        }
    });
  
    return store;
}